/**
 * Created by Ning Jiang on 9/18/2019.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineLite} from "gsap";
import {DragonTribeGameConfig} from "../../DragonTribeGameConfig";

export class ScatterWinView extends BaseView {

    private _layer:ScalableLayer;

    constructor() {
        super();
        this._layer = StageManager.getLayer(DragonTribeGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name);
    }

    public getScatterWinAnimation(reelId:number, symId:number, symbol:StateReelSymbol):TimelineLite {
        const sprite:TimelineSprite = new TimelineSprite(GameResources.getTextures("S_win"));
        sprite.anchor.set(0.5, 0.5);
        sprite.visible = false;
        const position:[number, number] = Helper.getSymbolPositions(reelId, symId, true);
        sprite.position.set(position[0], position[1]);
        this._layer.addChild(sprite);
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            sprite.getAnimationAutoShowHide(),
            () => symbol.setVisibility(false)
        ]);
        timeline.add(()=> symbol.setVisibility(true));
        timeline.add(() => this._layer.removeChild(sprite));

        return timeline;
    }
}